var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Loading } from 'element-ui';
import { Component } from 'vue-property-decorator';
import BindedStoreService from "../../api/UserService";
import ClientService from '../../api/ClientService';
import AddStore from "./components/AddStore.vue";
var SaleMandetais = (function (_super) {
    __extends(SaleMandetais, _super);
    function SaleMandetais() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listData = [];
        _this.total = 0;
        _this.tableHeight = 0;
        _this.rowData = null;
        return _this;
    }
    SaleMandetais.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 325;
        }, 300);
        console.log(111, this.rowData);
        this.getbindedList();
    };
    SaleMandetais.prototype.created = function () {
        this.service = BindedStoreService.getInstance();
        this.ClientService = ClientService.getInstance();
    };
    SaleMandetais.prototype.selectionChange = function (rows) {
        this.selectRows = rows;
    };
    SaleMandetais.prototype.pageChange = function (pager) {
        this.getbindedList(pager);
    };
    SaleMandetais.prototype.getSelectIds = function () {
        var shop_ids = this.selectRows.map(function (item) { return item.shop_id; });
        return shop_ids.join(',');
    };
    SaleMandetais.prototype.getbindedList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            account_id: this.rowData.account_id
        };
        this.service.getbindedStore(Object.assign({}, params, pager)).then(function (res) {
            console.log(666, res.data);
            _this.listData = res.data.data;
            _this.total = res.data.total;
            loadingInstance.close();
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
            loadingInstance.close();
        });
    };
    SaleMandetais.prototype.unBindStore = function () {
        var _this = this;
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.error('请先选择门店进行解绑！');
            return true;
        }
        this.$confirm('确定后会将用户与门店进行解绑，确定解绑吗？', '解绑门店').then(function (res) {
            var params = {
                shop_ids: _this.getSelectIds(),
                account_ids: _this.rowData.account_id,
            };
            _this.ClientService.unbindUser(params).then(function (res) {
                _this.getbindedList();
            }).catch(function (err) {
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    SaleMandetais.prototype.bindStore = function () {
        var _this = this;
        var dialog = this.$dialog(AddStore, {
            data: {
                account_id: this.rowData.account_id
            }
        }, {
            title: "选择门店",
            width: 950,
            height: 500
        });
        dialog.instance.$on("save:ok", function (res) {
            var loadingInstance = Loading.service({ fullscreen: true });
            var params = {
                account_ids: res.account,
                shop_ids: res.data.toString()
            };
            _this.service.bindUsertoStore(params).then(function (res) {
                loadingInstance.close();
                _this.$message.success('操作成功');
                _this.getbindedList();
            }).catch(function (err) {
                _this.$message.error(err.msg || err.message);
                loadingInstance.close();
            });
            dialog.instance.close();
        });
    };
    SaleMandetais = __decorate([
        Component({})
    ], SaleMandetais);
    return SaleMandetais;
}(Vue));
export default SaleMandetais;
